import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ICountry } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey } from 'src/app/services/mapping.service';
import { statusObj } from 'src/app/dummy/status';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-country',
  templateUrl: './add-country.component.html',
  styleUrls: ['./add-country.component.scss']
})
export class AddCountryComponent implements OnInit {
  @ViewChild("focus",{static:false}) inputRef:ElementRef;

  form: FormGroup;
  code: AbstractControl;
  name: AbstractControl;
  description: AbstractControl;


  constructor(
    public dialogRef: MatDialogRef<AddCountryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.required],
      name: [null, Validators.required],
      description: [null],
    });
    this.code = this.form.controls['code'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
  }

  create(f: any, isNew: boolean) {
    if(this.form.valid){
      this.form.disable()
      const { code, name, description } = f;
      const item: ICountry = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        code: code,
        name: name,
        flag: null,
        description: description,
        status: statusObj.active,
        geoPoint: null,
      }
      this.store.save(this.ds.countryRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Country has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
    
  }

}
